import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import ProcessDevice from './ProcessDevice';
import OurProductsSection from "./OurProductsSection"

import '../styles/IndustrialRobots.css';

import IndustrialRobotsImg from '../assets/IndustrialRobotsImg.jpg'

const IndustrialRobots = () => {

  return (
    <div className="IndustrialRobots">
      <Header />

      {/* Hero Banner Section */}
      {/* <section className="hero-banner7">
        <div className="hero-content">
          <h1>AUTOMOBILES AND PARTS</h1>
          <div className="breadcrumb">
            <span><a href="/" style={{ color: "#ACECFC" }}>Home</a></span> ⪢ <span>Automobiles And Parts</span>
          </div>
        </div>
      </section> */}

<section className="IndustrialRobots-hero-clean">
  <div className="hero-text">
    <h1>Industrial Robots Industry</h1>
    <p>
      Whether condition monitoring or collaboration between humans and robots, machines and actuators, We offer you with a comprehensive portfolio of sensor technology.
    </p>
  </div>
  <br/>
  <div className="hero-image">
    <img src={IndustrialRobotsImg} alt="Industrial Robots Industry" />
  </div>
</section>


<ProcessDevice />
<OurProductsSection />

      <Footer />
    </div>
  );
};
export default IndustrialRobots;